import { Currency, Region } from 'evee-ui-common/enums';
import cookies from 'evee-ui-common/services/cookies';

import { DEFAULT_HEADER_NOTIFICATION_MODE } from './constants';

const isCookiesAccepted = cookies.isCookiesAccepted();

export default {
  isLoading: false,
  isInitComplete: false,
  cookiesAccepted: isCookiesAccepted,
  headerNotification: {
    open: false,
    dismissed: false,
    mode: DEFAULT_HEADER_NOTIFICATION_MODE,
  },
  notificationCounts: {
    message: 0,
    rewards: 0,
  },
  region: Region.australia,
  currency: Currency.aud,
  toast: {
    open: false,
    message: '',
    type: '',
  },
};
